var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"6","height":"10","viewBox":"0 0 6 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.916016 0.416626L4.92643 4.99996L0.916016 9.58329","stroke":"#828282"}})])}
var staticRenderFns = []

export { render, staticRenderFns }